import axios from 'axios';

import * as mappers from './serviceMappers';

export function fetchAisVersionList() {
  return axios
    .get('ais-versions/')
    .then((response) => mappers.mapFetchAisVersionListResponse(response.data));
}

export function checkAisVersions() {
  return axios.post('ais-versions/check');
}

export function exportAisVersions(locale) {
  return axios.get('ais-versions/export', { params: { locale }, responseType: 'arraybuffer' });
}
